<template functional>
    <div
        :class="[
            'vf-padded-container',
            data.staticClass,
            data.class,
            {
                'vf-padded-container--bordered': props.isBordered,
                'vf-x-tight-padding': props.size === injections.SIZES.SMALL,
                'vf-xx-loose-padding': props.size === injections.SIZES.LARGE
            }
        ]"
    >
        <slot />
    </div>
</template>

<script>
import { SIZES } from 'design-assets/constants/sizes.js';
import VueTypes from 'commons/util/vue-types.js';

const VALID_SIZES = [ SIZES.SMALL, SIZES.LARGE ];

export default {
    props: {
        size: VueTypes.oneOf(VALID_SIZES).def(SIZES.SMALL),
        isBordered: VueTypes.bool.def(false),
    },
    inject: {
        SIZES: { default: SIZES },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../css/variables/module';

.vf-padded-container {
    border: 1px solid transparent;
    border-radius: 5px;
}

.vf-padded-container--bordered {
    @include var(border-color, 'primary-color-10');
}
</style>
